import React from 'react'
import Modal from 'components/Modal/Modal'
import { Button, Form } from 'react-bootstrap'
import ReactLoading from 'react-loader-spinner'
import useDeleteFavoris from 'hooks/useDeleteFavoris'
import pluralizer from 'utils/pluralizer'
import cn from 'classnames'
import s from './DeleteFavoris.module.scss'

interface Props {
  className?: string
  disabled?: boolean
  children: React.ReactNode
}

const defaultProps = {
  className: undefined,
  disabled: false,
}

const DeleteFavoris = ({
  className,
  disabled,
  children,
}: Props): JSX.Element => {
  const {
    show,
    loading,
    error,
    showModal,
    confirmDeleteSelectedFavoris,
    cancelDeleteFavoris,
    countFavorisChecked,
  } = useDeleteFavoris()

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    confirmDeleteSelectedFavoris()
  }

  return (
    <>
      <Button
        className={cn('btn-delete-favoris', className)}
        onClick={showModal}
        disabled={disabled}
      >
        {children}
      </Button>
      <Modal
        additionalModalClassNames={s.modal}
        show={show}
        title="Supprimer un bien favoris"
        onCloseButtonClick={cancelDeleteFavoris}
        body={
          <>
            <Form className={s.form} onSubmit={handleSubmit}>
              <h2
                className={s.title}
                // eslint-disable-next-line react/no-danger -- Not a danger because value not from public API. Needed to apply the bold style
                dangerouslySetInnerHTML={{
                  __html: pluralizer(
                    [
                      '',
                      'Souhaitez-vous supprimer votre favoris sélectionné ?',
                      'Souhaitez-vous supprimer vos <b>{{count}} favoris</b> sélectionnés ?',
                    ],
                    countFavorisChecked
                  ),
                }}
              />
              <p className={s.text}>Cette action est définitive.</p>
              <Button
                className={cn(s.btn, s.cancel)}
                variant="outline-primary"
                onClick={cancelDeleteFavoris}
              >
                Annuler
              </Button>
              <Button className={cn(s.btn, s.confirm)} type="submit">
                {loading ? (
                  <ReactLoading type="Oval" color="#fff" height="2.4rem" />
                ) : (
                  'Confirmer'
                )}
              </Button>
            </Form>
            {error && <p className="text-danger text-center">{error}</p>}
          </>
        }
      />
    </>
  )
}

DeleteFavoris.defaultProps = defaultProps
export default DeleteFavoris
